import '@babel/polyfill'
import 'whatwg-fetch'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n';
import Amplify from 'aws-amplify';
import awsExports from './aws-exports';

Vue.config.productionTip = false
Amplify.Logger.LOG_LEVEL = process.env.NODE_ENV === 'development' ? 'DEBUG' : 'ERROR';
Amplify.configure(awsExports);

if (window.fetch === undefined) {
  window.fetch = fetch;
}

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
